export default __webpack_public_path__ + "static/media/close-modal.937b681e.svg";